import { render } from "./Ask.vue?vue&type=template&id=07c285f6"
import script from "./Ask.vue?vue&type=script&lang=js"
export * from "./Ask.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__